import NProgress from 'nprogress';

import {
  FULL_PAGE_RELOAD_PROGRESS_TIMEOUT_MS,
  ROUTE_PROGRESS_BAR_ID,
} from '@/shared/config/routeProgress';

let fullPageReloadCleanupTimer: ReturnType<typeof setTimeout> | null = null;

/**
 * 참고
 *
 * - https://github.com/rstacruz/nprogress/issues/103
 *
 * - https://github.com/rstacruz/nprogress/pull/129
 */
export const safeExecuteRouteProgress = (action: () => void) => {
  try {
    const progressBarElement = document.getElementById(ROUTE_PROGRESS_BAR_ID);
    if (progressBarElement) {
      action();
    }
  } catch (error) {
    console.error('Progress bar operation failed:', error);
  }
};

export const startRouteProgress = () => {
  if (NProgress.isStarted()) {
    return;
  }

  safeExecuteRouteProgress(() => NProgress.start());
};

export const doneRouteProgress = () => {
  if (!NProgress.isStarted()) {
    return;
  }

  safeExecuteRouteProgress(() => NProgress.done(false));
};

export const navigateWithFullPageReload = (href: string) => {
  if (fullPageReloadCleanupTimer !== null) {
    clearTimeout(fullPageReloadCleanupTimer);
  }

  startRouteProgress();

  fullPageReloadCleanupTimer = setTimeout(() => {
    fullPageReloadCleanupTimer = null;
    doneRouteProgress();
  }, FULL_PAGE_RELOAD_PROGRESS_TIMEOUT_MS);

  window.location.href = href;
};
